module.exports = __webpack_public_path__ + "img/img2_8.0d984f0c.jpeg";